import React, { useEffect } from "react";
import { Modal } from "antd";
const { confirm } = Modal;

const NewVersion = () => {
  useEffect(() => {
    if ("isUpdateAvailable" in window) {
      window["isUpdateAvailable"].then((isAvailable) => {
        console.log(
          "[Service Worker] useEffect isUpdateAvailable isAvailable "
        );
        console.log(
          "[Service Worker] useEffect isUpdateAvailable isAvailable change "
        );

        if (isAvailable) {
          confirm({
            title: "نسخه جدید لاوین در دسترس است.",
            content: "با زدن روی دکمه بروزرسانی آخرین تغییرات را دریافت کنید",
            icon: (
              <span aria-label="Update" role="img">
                🎉
              </span>
            ),
            okText: "بروزرسانی",
            cancelText: "لغو ",
            onOk() {
              window.location.reload();
            },
            onCancel() {
              console.log("Cancel");
            },
          });
        }
      });
    }
  }, []);

  return <div />;
};

export default NewVersion;
